module.exports = __webpack_public_path__ + "static/media/restaurant_image.2fad47a0.jpg";